import type { AxiosRequestConfig } from "axios";

import type { PolicyConsentPayloadDTO } from "@/core/types";
import { httpAuth } from "@/utils/axios";

export type AppendPatientConsentResponse = {
  message: string;
};

export const patientRequestsTyped = {
  append_patient_consent: function ({
    data,
    params,
  }: {
    data: PolicyConsentPayloadDTO;
    params?: Record<string, unknown>;
  }) {
    const config = {
      method: "post",
      url: "/v1/patient/append_consent",
      data,
      params,
      preventAllErrorToast: true,
      /** TODO: Create a type for this API client that extends the AxiosRequestConfig type with all extra params */
    } satisfies AxiosRequestConfig & {
      preventAllErrorToast: boolean;
    };

    return httpAuth(config) as unknown as Promise<AppendPatientConsentResponse>;
  },
};
